import React from "react";
import { isLoggedIn } from "../components/Utils";

export default class Intro extends React.Component {

  componentWillMount() {
    if (!isLoggedIn()) {
      browserHistory.push("/");
      return;
    }
  }

  render() {
    return (<div className="content-container">
        <div className="section-top">
          <h1>Gebruiksvoorwaarden NIBHV</h1>
        </div>
        <div className="content">
          <p>Deze Gebruiksvoorwaarden zijn van toepassing op de toegang tot en
            het gebruik van de online NIBHV Competent Portalen (NIBHV
            Portaal, NIBHV Praktijk, NIBHV Theorie en Mijn NIBHV) voor
            opleiders, instructeurs en cursisten. Door als Gebruiker een
            account aan te maken, in te loggen en gebruik te maken van een
            Portaal ga je akkoord met deze Gebruiksvoorwaarden. Wij raden je
            aan om deze Gebruiksvoorwaarden zorgvuldig en regelmatig door te
            lezen voordat je gebruik maakt van een Portaal.</p>
          <h2 id="1-definities">1. Definities</h2>
          <p>In deze Gebruiksvoorwaarden hebben de volgende met een
            hoofdletter geschreven begrippen (zowel in enkelvoud als in
            meervoud) de daarbij behorende betekenis:</p>
          <p><strong>Account</strong>: het door NIBHV aan Gebruiker verleende
            recht van toegang tot één of meer van de NIBHV Competent
            Portalen</p>
          <p><strong>Gebruiker</strong>: de persoon die al dan niet in het
            kader van zijn bedrijf op beroep toegang heeft tot en gebruik
            maakt van een Portaal. In het geval dat de betreffende persoon
            in dienst is van of anderszins handelt namens een rechtspersoon
            worden zowel de betreffende persoon als de rechtspersoon als
            Gebruiker beschouwd.</p>
          <p><strong>Gebruiksvoorwaarden</strong>: deze gebruiksvoorwaarden
          </p>
          <p><strong>NIBHV</strong>: NIBHV B.V. (Nederlands Instituut voor
            Bedrijfshulpverlening), Hoofdweg 234, 3067GJ Rotterdam</p>
          <p><strong>Portaal</strong>: één van de volgende door NIBHV
            aangeboden online portalen:</p>
          <ul>
            <li>NIBHV Portaal, voor opleiders</li>
            <li>NIBHV Praktijk, voor instructeurs</li>
            <li>NIBHV Theorie, voor instructeurs</li>
            <li>Mijn NIBHV, voor cursisten</li>
          </ul>
          <h2 id="2-toepasselijkheid-gebruiksvoorwaarden">2. Toepasselijkheid
            Gebruiksvoorwaarden</h2>
          <p>2.1. De Gebruiksvoorwaarden zijn van toepassing op ieder gebruik
            door Gebruiker van een Portaal.</p>
          <p>2.2. De toepasselijkheid van de Gebruiksvoorwaarden wordt door de
            Gebruiker aanvaard door in te loggen in een Portaal.</p>
          <p>2.3. Deze Gebruiksvoorwaarden vormen een overeenkomst tussen
            Gebruiker en NIBHV.</p>
          <p>2.4. Indien één of meer bepalingen uit deze Gebruiksvoorwaarden
            nietig blijken te zijn, vernietigd worden of anderszins hun
            geldigheid verliezen, heeft NIBHV het recht deze bepaling(en) te
            vervangen en zullen de overige bepalingen van de
            Gebruiksvoorwaarden zoveel mogelijk van kracht blijven.</p>
          <h2 id="3-account">3. Account</h2>
          <p>3.1. Voor het aanmaken en tot stand komen van een Account dient
            Gebruiker, al naar gelang het Portaal waar hij toegang tot wenst
            te verkrijgen, de volgende gegevens te verstrekken:</p>
          <ul>
            <li>Naam</li>
            <li>Geboortedatum</li>
            <li>E-mailadres</li>
            <li>Functie</li>
            <li>Werkgever</li>
            <li>Instructeursbevoegdheden</li>
            <li>Bedrijfsnaam</li>
            <li>Gebruikersnaam</li>
            <li>Wachtwoord</li>
          </ul>
          <p>3.2. Gebruiker is verantwoordelijk voor de juistheid,
            nauwkeurigheid en volledigheid van de door hem verschafte
            gegevens. Gebruiker is verantwoordelijk voor het geheimhouden
            van de gegevens betreffende zijn Account, waaronder zijn
            gebruikersnaam en wachtwoord.</p>
          <p>3.3. Het Account is persoonlijk. Gebruiker is niet gerechtigd
            anderen gebruik te laten maken van het Account en deze anderen
            toegang te verschaffen tot de Portalen.</p>
          <p>3.4. Gebruiker kan het Account opzeggen door een bericht te naar
            info@nibhv.nl. Daarmee eindigt onmiddellijk het recht van de
            Gebruiker op het gebruik van de Portalen.</p>
          <p>3.5. NIBHV kan een Gebruiker de toegang tot de Portalen ontzeggen
            en diens account beëindigen indien:</p>
          <p>3.5.1. Gebruiker naar het oordeel van NIBHV gebruik maakt van de
            Portalen op een wijze die in strijd is met de
            Gebruiksvoorwaarden;</p>
          <p>3.5.2. Gebruiker naar het oordeel van NIBHV door enig doen of
            nalaten afbreuk doet aan de belangen en/of de reputatie van
            NIBHV of derden, of aan het belang van bedrijfshulpverlening in
            het algemeen;</p>
          <p>3.5.3. Gebruiker enige overeenkomst met NIBHV niet nakomt;</p>
          <p>3.5.4. Gebruiker niet langer in dienst is van of anderszins werkt
            voor de rechtspersoon waarvoor hij als Gebruiker optrad;</p>
          <p>3.5.5. Gebruiker is opgehouden te bestaan of ontbonden;</p>
          <p>3.5.6. Gebruiker in staat van faillissement is verklaard; aan
            hem, al dan niet voorlopig, surséance van betaling is verleend;
            op Gebruiker een andere gelijksoortige regeling van toepassing
            is geworden; Gebruiker anderszins geheel of gedeeltelijk het
            vrije beheer of de beschikking over zijn vermogen heeft
            verloren; een en ander ongeacht of die toestand onherroepelijk
            is.</p>
          <h2 id="4-gebruik-portaal">4. Gebruik Portaal</h2>
          <p>4.1. Het is Gebruiker niet toegestaan om de Portalen in strijd
            met de wet, rechten van derden of deze Gebruiksvoorwaarden te
            gebruiken, op een manier te gebruiken die het functioneren van
            het Portaal door derden kan hinderen en/of in het Portaal
            aangeboden informatie of onderliggende software kan aantasten,
            dan wel anderszins onrechtmatig te handelen jegens NIBHV of
            derden.</p>
          <p>4.2. Gebruiker zal alle redelijke instructies van NIBHV omtrent
            het gebruik van de Portalen opvolgen.</p>
          <p>4.3. Gebruiker dient te zorgen voor adequate beveiliging van de
            apparatuur waarmee hij zich toegang tot de Portalen
            verschaft.</p>
          <p>4.4. NIBHV kan besluiten om de functionaliteit van een Portaal te
            wijzigen.</p>
          <p>4.5. NIBHV kan de Portalen buiten gebruik stellen of het gebruik
            daarvan tijdelijk beperken, bijvoorbeeld indien dit naar de
            mening van NIBHV noodzakelijk is in verband met aanpassingen,
            wijzigingen of aanvullingen of het verrichten van onderhoud aan
            de Portalen. Gebruiker vrijwaart NIBHV voor alle
            aansprakelijkheid voor eventuele gevolgen die deze
            buitengebruikstelling of beperking voor Gebruiker met zich mee
            kan brengen.</p>
          <h2 id="5-vergoeding">5. Vergoeding</h2>
          <p>5.1. Met uitzondering van het NIBHV Portaal is Gebruiker, tenzij
            anders overeengekomen, aan NIBHV geen vergoeding verschuldigd
            voor het gebruik van de Portalen.</p>
          <p>5.2. Voor het gebruik van het NIBHV Portaal is een eenmalige
            vergoeding verschuldigd. Deze vergoeding wordt bij het aanmaken
            van een Account dat toegang geeft tot het NIBHV Portaal in
            rekening gebracht. NIBHV kan de toegang van een Gebruiker die de
            in rekening gebrachte vergoeding niet of niet tijdig heeft
            betaald blokkeren.</p>
          <p>5.2. Indien geen vergoeding met Gebruiker is overeengekomen en
            NIBHV alsnog een vergoeding voor het toekomstig gebruik van de
            Portalen van Gebruiker wenst te ontvangen zal NIBHV daarvoor
            tijdig een voorstel doen. Indien Gebruiker dit voorstel niet
            aanvaardt zal NIBHV het Account kunnen beëindigen met
            inachtneming van een redelijke termijn.</p>
          <h2 id="6-aansprakelijkheid">6. Aansprakelijkheid</h2>
          <p>6.1. NIBHV aanvaardt geen enkele aansprakelijkheid voor schade
            die Gebruiker lijdt door het gebruik van of tekortkomingen aan
            de Portalen of de daarin opgenomen gegevens, waaronder maar niet
            beperkt tot virussen, defecten of overige onvolkomenheden aan
            apparatuur en andere software in verband met de toegang tot of
            het gebruik van de Portalen, het wijzigen, onderscheppen of
            oneigenlijk gebruik van informatie in de Portalen, de
            beschikbaarheid en/of werking van de Portalen, misbruik of
            verkeerd of oneigenlijk gebruik van (gegevens in) de Portalen,
            verlies of vervorming van gegevens, downloaden of gebruiken van
            gegevens in de Portalen, en/of aanspraken van derden in verband
            met de toegang tot en het gebruik van de Portalen of de daarin
            opgenomen gegevens.</p>
          <p>6.2. Iedere aansprakelijkheid van NIBHV voor andere schade dan
            directe schade, zoals gevolgschade, afgeleide schade en
            immateriële schade, is geheel uitgesloten.</p>
          <h2 id="7-overmacht">7. Overmacht</h2>
          <p>7.1. NIBHV is niet gehouden tot het verschaffen van toegang tot
            de Portalen of het werkend houden daarvan indien zij daartoe
            verhinderd is als gevolg van een niet toerekenbare tekortkoming,
            daaronder begrepen een tekortkoming van derden van wiens
            diensten NIBHV gebruik maakt.</p>
          <h2 id="8-persoonsgegevens">8. Persoonsgegevens</h2>
          <p>8.1. Op de verwerking van persoonsgegevens van Gebruiker door
            NIBHV is het privacy statement van NIBHV van toepassing, dat te
            vinden is op de website van NIBHV.</p>
          <p>8.2. Voor de verwerking van persoonsgegevens in het kader van het
            gebruik van de Portalen door de Gebruiker is Gebruiker
            verwerkingsverantwoordelijke in de zin van de Algemene
            verordening persoonsgegevens (AVG). Gebruiker zal bij de
            verwerking van persoonsgegevens in het kader van het gebruik van
            de Portalen niet in strijd handelen met de AVG, en vrijwaart
            NIBHV van aanspraken terzake van dergelijk handelen door
            Gebruiker.</p>
          <h2 id="9-intellectuele-eigendom">9. Intellectuele eigendom</h2>
          <p>9.1. Alle (intellectuele) eigendomsrechten, waaronder maar niet
            beperkt tot merken, handelsnamen, auteursrechten met betrekking
            tot NIBHV, de Portalen, de daarin opgenomen gegevens en de
            onderliggende software berusten bij NIBHV.</p>
          <p>9.2. Niets van de Portalen of de daarin opgenomen gegevens mag
            worden verveelvoudigd en openbaar gemaakt zonder de
            uitdrukkelijke toestemming van NIBHV.</p>
          <p>9.3. Niets uit de Gebruiksvoorwaarden zal worden uitgelegd als
            het verlenen van een licentie of recht uit hoofde van
            auteursrecht of enig ander intellectueel eigendomsrecht van
            NIBHV.</p>
          <h2 id="10-geheimhouding">10. Geheimhouding</h2>
          <p>10.1. Gebruikers zullen alle informatie betreffende de Portalen
            en de daarin opgenomen gegevens geheimhouden. Voor zover
            Gebruikers rechtspersonen zijn staan zij ervoor in dat de
            personen die in hun naam toegang hebben tot de Portalen of de
            daarin opgenomen gegevens door een arbeids- en/of een
            geheimhoudingsovereenkomst verplicht zijn tot geheimhouding.</p>
          <h2 id="11-toepasselijk-recht-en-bevoegde-rechter">11. Toepasselijk
            recht en bevoegde rechter</h2>
          <p>11.1. Op de Gebruiksvoorwaarden (en dus op het gebruik van de
            Portalen) is Nederlands recht van toepassing.</p>
          <p>11.2. Eventuele geschillen die in verband met de
            Gebruiksvoorwaarden en het gebruik van de Portalen ontstaan,
            geschillen over het bestaan en de geldigheid daarvan daaronder
            begrepen, zullen uitsluitend worden voorgelegd aan de rechtbank
            te Rotterdam.</p>
          <h2 id="12-wijzigingen-en-versie">12. Wijzigingen en versie</h2>
          <p>12.1. De Gebruiksvoorwaarden kunnen door NIBHV worden gewijzigd.
            De gewijzigde Gebruiksvoorwaarden zullen van toepassing zijn
            zodra zij aan Gebruiker kenbaar zijn gemaakt door publicatie in
            de Portalen, en/of door toezending van de gewijzigde
            Gebruiksvoorwaarden aan het e-mailadres van Gebruiker. Als
            Gebruiker zich na de kenbaar making van de wijziging van de
            Gebruiksvoorwaarden toegang verschaft de Portalen aanvaardt hij
            daarmee de toepasselijkheid van die gewijzigde
            Gebruiksvoorwaarden.</p>
          <p>12.2. Deze versie van de Gebruiksvoorwaarden dateert van 30
            september 2025.</p>
        </div>
        <button className="btn btn-primary" onClick={() => history.go(-1)}>
          Terug
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/TermsOfUse.js